import { formatDateOrdinalWithClock } from '~/services/TimeService';

const dateFormatter = (value: string) => formatDateOrdinalWithClock(value);

export default dateFormatter;
